const rootPath = ""

export default rootPath